import { render, staticRenderFns } from "./ProposalFilters.vue?vue&type=template&id=d6c09baa"
import script from "./ProposalFilters.vue?vue&type=script&lang=js"
export * from "./ProposalFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports